import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { AlarmTypeFailure, AlarmTypeRequest, AlarmTypeSuccess } from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'alarmType';

export interface State {
  data: ParameterResult | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(AlarmTypeFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(AlarmTypeRequest, state => ({ ...state, error: null, loading: true })),
    on(AlarmTypeSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
